<template lang='pug'>
  .fpui-accordion-section
    .fpui-accordion-head(@click="toggle")
      span {{header | translate}}
      i.fpui(:class="{'fpui-chevron-down':!open,'fpui-chevron-up':open}")
    .fpui-accordion-content(v-if="open")
      slot
</template>

<script>

export default {
  name: 'fpui-accordion-section',
  props: {
    header: String,
    active: Boolean
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    }
  },
  mounted () {
    if (this.active) {
      this.open = true
    }
  }
}
</script>

<style lang='less'>
  .fpui-accordion-content {
    padding:10px 20px 20px;
  }
  .fpui-accordion-head {
    position: relative;
    cursor:pointer;
    &:before {
      content:"";
      width:100%;
      height:1px;
      background-color: #eee;
      position: absolute;
      left:0;
      right:0;
      top:50%;
      z-index:1;
    }
    span {
      background:white;
      font-size:23px;
      font-family: "Josefin Sans";
      font-weight:400;
      display: inline-block;
      z-index:2;
      position: relative;
      padding:0 10px;
    }
    i.fpui {
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      color:#10B6E9;
      font-size:20px;
      z-index:2;
      background:white;
      padding:2px 10px;
    }
  }
</style>
